export const SAVE_DEBOUNCE_MS = 800;
export const SAVE_IDLE_DELAY_MS = 2000;
